module.exports = __webpack_public_path__ + "static/media/qa-question.4df1ec10.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/OnboardingDemo/assets/qa-question.png
// module id = 478
// module chunks = 0